import { FormattedMessage } from 'react-intl';
import { Formik } from 'formik';
import { PoolButton, PoolModal, PoolModalActions, PoolModalContent, PoolModalTitle } from '@synergy/components-next';
import { ReactElement } from 'react';

import { SingleInquiryContent } from './single-inquiry-content';
import { singleInquiryDataSelector } from '../../../store/single-inquiry-selectors';
import { singleInquiryValidationSchema } from './single-inquiry-validation-schema';
import { useAppSelector } from '../../../../store/store';
import { useSingleInquiryContext } from './single-inquiry';

export const SingleInquiryModal = (): ReactElement | null => {
    const { isOpen, initialValues } = useAppSelector(singleInquiryDataSelector);
    const { onClose, onSubmit } = useSingleInquiryContext();

    return (
        <PoolModal maxWidth="lg" open={isOpen} onClose={onClose}>
            <Formik initialValues={initialValues} onSubmit={onSubmit} validationSchema={singleInquiryValidationSchema}>
                {formikProps => (
                    <>
                        <PoolModalTitle>
                            <FormattedMessage id="app.modal.title.singleInquiry" />
                        </PoolModalTitle>
                        <PoolModalContent>
                            <SingleInquiryContent />
                        </PoolModalContent>
                        <PoolModalActions>
                            <PoolButton variant="outlined" onClick={onClose}>
                                <FormattedMessage id="app.common.cancel" />
                            </PoolButton>
                            <PoolButton onClick={() => formikProps.handleSubmit()}>
                                <FormattedMessage id="app.singleInquiry" />
                            </PoolButton>
                        </PoolModalActions>
                    </>
                )}
            </Formik>
        </PoolModal>
    );
};
